import { trans } from '@pepita-i18n/babelfish';
import gtxConstants from 'gtx-constants';
import { extractFeaturesToggles } from 'lib/extractFeatureConfig';
import { immobiliareBaseUrl } from './immobiliareBaseUrl';

export const SecurityFooter = () => {
    const featureToggle = extractFeaturesToggles();

    return (
        <div className="login-desc__footer">
            <ul className="gx-body-tiny">
                <li>
                    <a href={immobiliareBaseUrl} target="_blank">
                        {trans('label.home')}
                    </a>
                </li>
                <li>
                    <a
                        href={gtxConstants('AD_PORTAL_ABOUT_US_URL')}
                        target="_blank"
                    >
                        {trans('label.who_we_are')}
                    </a>
                </li>
                <li>
                    <a
                        href={gtxConstants('AD_PORTAL_CONTACT_US_URL')}
                        target="_blank"
                    >
                        {trans('label.contact_us')}
                    </a>
                </li>
                {featureToggle?.featuresConfig?.features?.news && (
                    <li>
                        <a href={immobiliareBaseUrl + '/news/'} target="_blank">
                            {trans('label.news')}
                        </a>
                    </li>
                )}
            </ul>
        </div>
    );
};
